import { atom } from "recoil";

export const songIdPlayingState = atom<any>({
    key: "songIdPlayingState",
    default: undefined
  });